import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import { useHomeContext } from '../../context'
import { Input } from '../../../../components/ui/input'
import { Button } from '../../../../components/ui/button'
import { StepItem } from '../../../../components/ui/stepItem'
import FindTeviIdModal from '../findTeviIdModal'

const Form = () => {
  const {
    teviId,
    setTeviId,
    inputStatus,
    statusMessage,
    isSubmitting,
    isDisabled,
    handleClear,
    handleSubmit,
    showFindIdModal,
    handleOpenFindIdModal,
    handleCloseFindIdModal,
    stepKeys,
    t,
  } = useHomeContext()

  return (
    <>
      <Box sx={{ position: 'relative', zIndex: 10, pt: 3 }}>
        {/* Title Section */}
        <Box sx={{ mb: 1.5 }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 14,
              color: '#1C1C1E',
              lineHeight: 1.4,
              letterSpacing: '-0.28px',
              mb: 1,
            }}
          >
            {t('form.description')}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 500,
              fontSize: 14,
              color: '#501BC0',
              lineHeight: 1.4,
              letterSpacing: '-0.28px',
            }}
          >
            {t('form.supportMessage')}
          </Typography>
        </Box>

        {/* How to Join Card */}
        <Paper
          elevation={0}
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(2px)',
            borderRadius: '16px',
            p: 1.5,
            mb: 3,
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              fontSize: 16,
              color: '#141414',
              letterSpacing: '-0.32px',
              mb: 0.5,
            }}
          >
            {t('form.howToJoin')}
          </Typography>

          <Stack spacing={0.5}>
            {stepKeys.map((key, index) => (
              <StepItem key={key} number={index + 1} text={t(`form.steps.${key}`)} />
            ))}
          </Stack>
        </Paper>

        {/* Input Section */}
        <Box>
          <Input
            label={t('form.input.label')}
            placeholder={t('form.input.placeholder')}
            value={teviId}
            onChange={setTeviId}
            showInfo
            onInfoClick={handleOpenFindIdModal}
            status={inputStatus}
            statusMessage={statusMessage}
            onClear={handleClear}
          />
          <FindTeviIdModal open={showFindIdModal} onClose={handleCloseFindIdModal} />
        </Box>
      </Box>

      {/* Submit button — sticky to viewport bottom while scrolling, settles at end of page */}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: 20,
          mx: -1.25,
          mt: 1,
          px: 1.25,
          py: 1.5,
          backgroundColor: 'rgba(237, 230, 255, 0.85)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      >
        <Button onClick={handleSubmit} loading={isSubmitting} disabled={isDisabled}>
          {t('form.submit')}
        </Button>
      </Box>

      {/* Submit note — natural position below the button, no sticky */}
      <Typography
        sx={{
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          fontSize: 12,
          color: 'rgba(19, 19, 19, 0.7)',
          position: 'relative',
          zIndex: 10,
        }}
      >
        {t('form.submitNote')}
        <br />
        {t('form.submitNote2')}
      </Typography>
    </>
  )
}

export default Form
